import Qs from 'qs'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'

export const CustomerAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const WidgetCacheAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.WIDGET_CACHE_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const ConversationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONVERSATION_API,
    paramsSerializer: (params) =>
      Qs.stringify(params, { arrayFormat: 'repeat' }),
  },
})

export const AccountsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ACCOUNTS_API,
  },
})

export const TicketAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.TICKET_API,
  },
})

export const MeetingsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.MEETINGS_API,
    raw: true,
  },
})

export const FlowAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.FLOW_API,
  },
})

export const ReportAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.REPORT_API,
    raw: true,
  },
})

export const RoutingAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.ROUTING_API,
  },
})
